import { createSlice } from '@reduxjs/toolkit';
import { getAllDrawers } from './thunks';

// Initial state for Redux store:
export const initialStateDrawers = {
  drawers: {
    total: 0,
    drawers: [],
    paginate: {
      current_page: 1,
      items: 0,
      pages: 1,
    },
    success: false,
  },
  loading: false,
};

const drawersSlice = createSlice({
  name: 'drawers',
  initialState: initialStateDrawers, // Define initial state
  reducers: {
    setDrawers: (state: any, action: any) => {
      state.drawers = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllDrawers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllDrawers.fulfilled, (state, action) => {
      state.drawers = action.payload;
      state.loading = false;
    });
  },
});

// Export actions generated by "createSlice()":
export const { setDrawers } = drawersSlice.actions;

// Export reducer generated by "createSlice()":
export default drawersSlice.reducer;
